<template>
	<div class="cme-options" v-if="Auth.checkPermission( 'VIEW_CYBER_SOLUTIONS' )">
		<h3>Cyber Solutions</h3>
		<p>As a {{ Brand.getProperBrand() }} policyholder, you have unlimited access to an online data security risk management service.</p>
		<p>
			<router-link to="/page/cyber_info" tag="button" class="btn btn-primary">Learn More</router-link>
		</p>
		<hr class="dashed">
	</div>
</template>

<script>
import Auth from '@/services/Auth';
import Brand from '@/services/Brand';

export default {
	name: 'CyberSolutions',
	data() {
		return {
			Auth,
			Brand
		};
	},
};
</script>
